// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"7ad94481","787":"53fac991","978":"bc876604"}[chunkId] + ".chunk.js";
};